import { UseFormWatch } from "react-hook-form";
import { selectorTransversal } from "../../../../dtos/selector";
import { operacion } from "../../models/operacion";
import { Dialog, DialogContent, DialogTitle, Grid2 } from "@mui/material";
import MButton from "../../../../components/inputs/yup/materialui/mButton";
import FormularioBusquedaTablaDesarrollo from "../../../maestros/tablasDesarrollo/components/formularioBusquedaTablaDesarrollo";
import { useEffect, useState } from "react";

interface IProps {
    idMutuo: number;
    show: boolean;
    onHide: () => void;
    watchParentForm: UseFormWatch<operacion>;
    clickLupaCuotaMaxima: boolean;
    clickLupaCuotaMinima: boolean;
    setTablaSeleccionada: React.Dispatch<React.SetStateAction<any | undefined>>;
}

const ModalBuscadorTablas: React.FC<IProps> = (props) => {

    const [acceptDisabled, setAcceptDisabled] = useState<boolean>(true)
    const [tablaSeleccionadaModal, setTablaSeleccionadaModal] = useState<any>(null)

    function customOnHide() {
        props.onHide()
    }

    function customSetTablaSeleccionada(e: any) {
        setTablaSeleccionadaModal(e);
        setAcceptDisabled(e === null || e === undefined);
    }

    function customSet() {
        props.setTablaSeleccionada(tablaSeleccionadaModal);
        customOnHide();
    }

    useEffect(() => {
        if (props.show){
            setAcceptDisabled(true)
        }
    }, [props.show])

    return (
        <Dialog
            open={props.show}
            onClose={customOnHide}
            maxWidth='xl'
        >
            <DialogTitle>
                Buscar tabla de desarrollo
            </DialogTitle>
            <DialogContent>
                <FormularioBusquedaTablaDesarrollo 
                    watchParentForm={props.watchParentForm}
                    clickLupaCuotaMaxima={props.clickLupaCuotaMaxima}
                    clickLupaCuotaMinima={props.clickLupaCuotaMinima}
                    setTablaSeleccionada={customSetTablaSeleccionada}
                    onHide={props.onHide}
                    isActionable={false}
                    onUpdate={() => {}}
                    onDelete={() => {}}
                    onCreate={() => {}}
                    onImport={() => {}}
                    onDetalle={() => {}}
                    onRestart={() => {setAcceptDisabled(true)}}
                    key={0}
                />
                <Grid2 container sx={{ textAlign: "right", justifyContent: 'flex-end', mt: 2, mb: 2 }} spacing={1}>
                    <MButton variant="contained" color="info" onClick={customOnHide}>
                        Cancelar
                    </MButton>
                    <MButton variant="contained" color="primary" onClick={customSet} disabled={acceptDisabled}>
                        Aceptar
                    </MButton>
                </Grid2>
            </DialogContent>
        </Dialog >
    )
}

export default ModalBuscadorTablas